import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { SaleInformationPageRoutingModule } from './sale-information-routing.module';
import { SaleInformationPageComponent } from './sale-information.page';

@NgModule({
  declarations: [SaleInformationPageComponent],
  imports: [FormsModule, IonicModule, SaleInformationPageRoutingModule, MiscModule, CommonModule]
})
export class SaleInformationPageModule {}
